import React from 'react';
import { MyCompanyType } from 'types';
import { Drawer } from '../shared/Drawer';
import AMCompanyDrawerHeaderFooter from './AMCompanyDrawerHeaderFooter';
import CompanyDrawerBody from './CompanyDrawerBody';
import { useMediaQuery } from '@mui/material';
import LeadPositionDrawer from '../position/LeadPositionDrawer';
import { useUserContext } from 'src/context/UserProvider';
import LeadViewDetailsDrawer from '../position/LeadViewDetailsDrawer';

interface Props {
	isCompanyDrawerOpen: boolean;
	company?: MyCompanyType['company'];
	setIsCompanyDrawerOpen: (val: boolean) => void;
	closeDrawer: () => void;
}

export interface PositionSkill {
	id: string;
	name: string;
	threshold: number;
	rating: number;
}

const AMCompanyDrawer = ({ isCompanyDrawerOpen, closeDrawer, company, setIsCompanyDrawerOpen }: Props) => {
	const isMobile = useMediaQuery('(max-width:960px)');
	const { isAccountManagerLoggedIn } = useUserContext();

	if (!company) return null;
	if (company.isLead && isAccountManagerLoggedIn)
		return (
			<LeadViewDetailsDrawer
				isPositionDrawerOpen={isCompanyDrawerOpen}
				company={company}
				setIsPositionDrawerOpen={setIsCompanyDrawerOpen}
				closeDrawer={closeDrawer}
			/>
			// <LeadPositionDrawer
			// 	isPositionDrawerOpen={isCompanyDrawerOpen}
			// 	company={company}
			// 	setIsPositionDrawerOpen={setIsCompanyDrawerOpen}
			// 	closeDrawer={() => setIsCompanyDrawerOpen(false)}
			// />
		);
	console.log("company 111=======>", company)
	return (
		<Drawer
			minHeight="348px"
			isModal={!isMobile}
			isOpen={isCompanyDrawerOpen}
			onClose={() => {
				setIsCompanyDrawerOpen(false);
			}}
			header={
				<div>
					<AMCompanyDrawerHeaderFooter companyDetail={company} isFooter={false} />
					<div className="flex justify-center">
						<hr className="h-[1px] w-full rounded-[32px] border-0 bg-[#C7C9D9] dark:bg-[#8F90A6]" />
					</div>
				</div>
			}
			body={
				<div className="px-[8px]">
					<CompanyDrawerBody company={company} />
				</div>
			}
			// footer={
			// 	<div
			// 		style={{
			// 			filter: 'drop-shadow(0px -4px 4px rgba(49, 49, 49, 0.25))',
			// 		}}
			// 		className="bg-[#E5F0FF] dark:bg-[#111E2C] md:hidden"
			// 	>
			// 		<AMCompanyDrawerHeaderFooter
			// 			setIsCompanyDrawerOpen={setIsCompanyDrawerOpen}
			// 			companyDetail={company}
			// 			isFooter={true}
			// 			closeDrawer={closeDrawer}
			// 		/>
			// 	</div>
			// }
		/>
	);
};

export default AMCompanyDrawer;
